// Production environment. Swapped in by angular.json `fileReplacements` for the production config.
//
// Every value can be overridden at runtime by an env var on the SSR Node process (see
// api.config.ts), so the same build artifact can be promoted dev -> staging -> production without
// rebuilding. The literals below are only the fallback defaults.
export const environment = {
  production: true,
  siteOrigin: 'https://www.savingarena.com',
  apiBaseUrl: 'https://www.savingarena.com/api/frontend',
  assetBaseUrl: 'https://www.savingarena.com',
  // During SSR the Node process talks to the backend directly rather than looping back out through
  // the public hostname/CDN — faster, and it keeps rendering alive if public DNS/TLS hiccups.
  serverApiBaseUrl: 'http://127.0.0.1:3001/api/frontend',
  // Dev/QA tooling (status mega-menu badges + static-section red dots) is OFF in production.
  // GA4 measurement ID. Public by nature - it is visible in every page's network requests - so it
  // belongs in the build rather than in a secret.
  gaMeasurementId: 'G-24TET7MQGV',
  devFlags: false,
};
